import React from 'react'

type Props = {}

function MessageForUsers({ }: Props) {
    return (
        <main className=' w-full bg-white text-[10px] p-2'>
            Users are advised to download Official ‘IRCTC Rail Connect’ Apps only from Google Play Store or Apple App Store. Please do not use unauthorized links/URLs.
            Please check the alert section regarding restoration of AC 3-tier economy fare.
        </main>
    )
}

export default MessageForUsers